export default "__VITE_ASSET__4b49057a__"